/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export enum ImbalanceFilter {
  WMS_ZERO = "WMS_ZERO",
  WMS_LESS_THAN_CI = "WMS_LESS_THAN_CI",
  WMS_MORE_THAN_CI = "WMS_MORE_THAN_CI",
}


export type ImbalanceConnection = {
  __typename: "ImbalanceConnection",
  items?:  Array<Imbalance | null > | null,
  nextToken?: string | null,
  totalCount?: number | null,
};

export type Imbalance = {
  __typename: "Imbalance",
  material?: string | null,
  size?: string | null,
  quality?: string | null,
  coo?: string | null,
  wmsQty?: number | null,
  ciBondedQty?: number | null,
  ciNonBondedQty?: number | null,
  ciTotalQty?: number | null,
  imbalance?: number | null,
  persistentImbalance?: number | null,
  direction?: string | null,
  cleanStatus?: string | null,
  flowInformation?: string | null,
};

export type InventoryReportsConnection = {
  __typename: "InventoryReportsConnection",
  reportS3Bucket?: string | null,
  reportRegion?: string | null,
  balancingReports?:  Array<InventoryReports | null > | null,
  stockReports?:  Array<InventoryReports | null > | null,
  stockContainerBolReports?:  Array<InventoryReports | null > | null,
};

export type InventoryReports = {
  __typename: "InventoryReports",
  location?: string | null,
  reports?:  Array<InventoryReport | null > | null,
};

export type InventoryReport = {
  __typename: "InventoryReport",
  path?: string | null,
  version?: string | null,
  preSignedUrl?: string | null,
};

export type ManualAdjustmentInput = {
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  location?: string | null,
  type?: Type | null,
  quantity?: number | null,
  customsStatus?: CustomsStatus | null,
  reason?: string | null,
  comment?: string | null,
  clearGoodsIfNeeded?: boolean | null,
};

export enum Type {
  POSADJ = "POSADJ",
  NEGADJ = "NEGADJ",
}


export enum CustomsStatus {
  BONDED = "BONDED",
  NON_BONDED = "NON_BONDED",
}


export type MutationAPIResponse = {
  __typename: "MutationAPIResponse",
  message?: string | null,
  success?: boolean | null,
  timestamp?: string | null,
};

export type GetImbalancesQueryVariables = {
  material?: string | null,
  size?: string | null,
  month: string,
  filter?: ImbalanceFilter | null,
  isPersistent?: boolean | null,
  excludeColors?: boolean | null,
  statusFilter?: string | null,
  nextToken?: string | null,
};

export type GetImbalancesQuery = {
  getImbalances?:  {
    __typename: "ImbalanceConnection",
    items?:  Array< {
      __typename: "Imbalance",
      material?: string | null,
      size?: string | null,
      quality?: string | null,
      coo?: string | null,
      wmsQty?: number | null,
      ciBondedQty?: number | null,
      ciNonBondedQty?: number | null,
      ciTotalQty?: number | null,
      imbalance?: number | null,
      persistentImbalance?: number | null,
      direction?: string | null,
      cleanStatus?: string | null,
      flowInformation?: string | null,
    } | null > | null,
    nextToken?: string | null,
    totalCount?: number | null,
  } | null,
};

export type GetInventoryReportsQueryVariables = {
};

export type GetInventoryReportsQuery = {
  getInventoryReports?:  {
    __typename: "InventoryReportsConnection",
    reportS3Bucket?: string | null,
    reportRegion?: string | null,
    balancingReports?:  Array< {
      __typename: "InventoryReports",
      location?: string | null,
      reports?:  Array< {
        __typename: "InventoryReport",
        path?: string | null,
        version?: string | null,
        preSignedUrl?: string | null,
      } | null > | null,
    } | null > | null,
    stockReports?:  Array< {
      __typename: "InventoryReports",
      location?: string | null,
      reports?:  Array< {
        __typename: "InventoryReport",
        path?: string | null,
        version?: string | null,
        preSignedUrl?: string | null,
      } | null > | null,
    } | null > | null,
    stockContainerBolReports?:  Array< {
      __typename: "InventoryReports",
      location?: string | null,
      reports?:  Array< {
        __typename: "InventoryReport",
        path?: string | null,
        version?: string | null,
        preSignedUrl?: string | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type SubmitManualAdjustmentsMutationVariables = {
  adjustments: Array< ManualAdjustmentInput >,
};

export type SubmitManualAdjustmentsMutation = {
  submitManualAdjustments?:  {
    __typename: "MutationAPIResponse",
    message?: string | null,
    success?: boolean | null,
    timestamp?: string | null,
  } | null,
};
